import React from 'react';
import { Card, Typography, Divider, Space } from 'antd';
import { CarOutlined, ClockCircleOutlined, EnvironmentOutlined, UserOutlined } from '@ant-design/icons';
import { formatDate } from '../utils/dateUtils';

const { Text, Title } = Typography;

/**
 * BreakdownRequestCard - Displays a non-clickable breakdown request summary
 * Mobile-first layout
 */
const BreakdownRequestCard = ({ request }) => {
  if (!request) return null;

  const {
    breakdownRequestReference,
    companyName,
    registrationNumber,
    fleetNumber,
    make,
    model,
    year,
    description,
    breakdownAddress,
    createdOn,
    controllerName,
    driverName,
  } = request;

  const vehicleInfo = [make, model, year].filter(Boolean).join(' | ');

  return (
    <Card className="breakdown-request-card" hoverable={false}>
      <div className="request-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div className="request-reference">
          <Title level={5} style={{ margin: 0 }}>{breakdownRequestReference}</Title>
        </div>
      </div>

      <Divider style={{ margin: '8px 0' }} />

      <div className="request-content" style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {/* Registration */}
        {registrationNumber && (
          <div className="registration-number">
            <Space>
              <CarOutlined />
              <Text strong>{registrationNumber}</Text>
            </Space>
          </div>
        )}

        {/* Fleet */}
        {fleetNumber && (
          <Text type="secondary">Fleet: {fleetNumber}</Text>
        )}

        {/* Vehicle */}
        {vehicleInfo && (
          <Text className="vehicle-info">{vehicleInfo}</Text>
        )}

        {/* Company */}
        {companyName && (
          <Text type="secondary" className="company-name">{companyName}</Text>
        )}

        {/* People */}
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          {controllerName && (
            <Space size={6}>
              <UserOutlined />
              <Text type="secondary">Controller: {controllerName}</Text>
            </Space>
          )}
          {driverName && (
            <Space size={6}>
              <UserOutlined />
              <Text type="secondary">Driver: {driverName}</Text>
            </Space>
          )}
        </div>

        {/* Description */}
        {description && (
          <div className="request-description" style={{ marginTop: 4 }}>
            <Text strong>Issue: </Text>
            <Text>{description}</Text>
          </div>
        )}

        {/* Footer */}
        <div className="request-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
          <Space>
            <ClockCircleOutlined />
            <Text type="secondary">{formatDate(createdOn)}</Text>
          </Space>

          {breakdownAddress && (
            <div className="request-address" style={{ maxWidth: '100%' }}>
              <Space>
                <EnvironmentOutlined />
                <Text type="secondary" ellipsis style={{ maxWidth: 220 }}>
                  {breakdownAddress}
                </Text>
              </Space>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default BreakdownRequestCard;
